import { useGlobalCurrency, useSetGlobalCurrency } from './store.js';
import { GLOBAL_CURRENCIES, type GlobalCurrency } from '../currency.js';

// Workspace-wide display-currency selector, lives in the top bar's right
// cluster. Sets `globalCurrency` in the store; monetary readouts that opt in
// (currently the Map's revenue filter) reformat to the chosen currency.

export function CurrencySelector() {
  const currency = useGlobalCurrency();
  const setCurrency = useSetGlobalCurrency();
  return (
    <select
      aria-label="Display currency"
      title="Display currency"
      value={currency}
      onChange={(e) => setCurrency(e.target.value as GlobalCurrency)}
      style={{
        fontSize: 'var(--t-meta)',
        fontFamily: 'var(--font-mono)',
        padding: '1px 4px',
        border: '1px solid var(--hairline)',
        borderRadius: 2,
        background: 'var(--menu-surface)',
        color: 'var(--text-primary)',
        cursor: 'pointer',
      }}
    >
      {GLOBAL_CURRENCIES.map((c) => (
        <option key={c} value={c}>
          {c}
        </option>
      ))}
    </select>
  );
}
